import { defineEvent } from '../types/event';
export var SORT_SELECT = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Sort_selected'
        }
    ]
});
